import React from 'react'
import { Plus, Check } from 'lucide-react';
import { MetricGrid, MetricCard, ActivityChart, C } from './AdminAnalyticsUI';

// Design 19a - three metric cards + "Activity over time" panel.
const CheckSquareIcon = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 11 12 14 22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

function AnalyticCasesCard({totalCount, xAxisValues, values, rangeLabel}) {
  return (
    <div className='flex flex-col w-full font-plexsans'>
      <MetricGrid cols={3}>
        <MetricCard
          icon={<Plus size={16} strokeWidth={2} color={C.green} />}
          tile="rgba(58,125,79,.1)"
          title="Cases created"
          value={totalCount?.created}
          desc="New cases posted by clients"
        />
        <MetricCard
          icon={<CheckSquareIcon color={C.brass} />}
          tile="rgba(138,98,49,.1)"
          title="Professional requests"
          value={totalCount?.requests}
          desc="Times a professional requested to view a case, including denials"
        />
        <MetricCard
          icon={<Check size={16} strokeWidth={2} color={C.navy} />}
          tile="rgba(20,33,61,.06)"
          title="Cases closed"
          value={totalCount?.closed}
          desc="Closed, deleted by client, or timed out"
        />
      </MetricGrid>
      <ActivityChart
        xAxisValues={xAxisValues}
        rangeLabel={rangeLabel}
        series={[
          { label: 'Cases created', color: C.green, data: values?.created },
          { label: 'Requests', color: C.brass, data: values?.requests },
          { label: 'Closed', color: C.red, data: values?.closed },
        ]}
      />
    </div>
  )
}

export default AnalyticCasesCard
